import { z } from 'zod';

export const candidatesMypageSettingSchema = z.object({
  title: z.string().min(1),
  status: z.string().min(1),
  is_show_job_post: z.boolean(),
  is_show_process: z.boolean(),
  is_show_uploader: z.boolean(),
  is_login_required: z.boolean(),
  login_id: z.string(),
  password: z.string(),
});

export type CandidatesMypageSettingSchema = z.infer<typeof candidatesMypageSettingSchema>;
